var GridPreferencePanelsValue = /*#__PURE__*/function (GridPreferencePanelsValue) {
  GridPreferencePanelsValue["filters"] = "filters";
  GridPreferencePanelsValue["columns"] = "columns";
  GridPreferencePanelsValue["aiAssistant"] = "aiAssistant";
  return GridPreferencePanelsValue;
}(GridPreferencePanelsValue || {});
export { GridPreferencePanelsValue };